import Vue from "vue";
import Router from "vue-router";

// Module Routes
import employeeRoutes from "./employee";
import catalogRoutes from "./catalog";
import rentAdjutment from "./rentAdjustment";
import purchaseRoutes from "./purchase";
import disposalRoutes from "./disposal";
import serviceRoutes from "./service";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    ...employeeRoutes,
    ...catalogRoutes,
    ...rentAdjutment,
    ...purchaseRoutes,
    ...disposalRoutes,
    ...serviceRoutes,
    {
      path: "/",
      name: "Login",
      component: require("@/components/LoginPage").default
    },
    {
      path: "/forgot",
      name: "Forgot",
      component: require("@/components/ForgotPasswordPage").default
    },
    {
      path: "/password",
      name: "ChangePassword",
      component: require("@/components/ChangePasswordPage").default
    },
    {
      path: "/home",
      name: "Home",
      component: require("@/components/LandingPage").default
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: require("@/components/DashboardPage").default
    },
    {
      path: "/order",
      name: "Order",
      component: require("@/components/Order/OrderPage").default
    },
    {
      path: "/order/endrent",
      name: "OrderEndRent",
      component: require("@/components/Order/OrderEndRentPage").default
    },
    {
      path: "/order/create",
      name: "OrderCreate",
      component: require("@/components/Order/OrderCreatePage").default
    },
    {
      path: "/return/schedule",
      name: "ReturnSchedule",
      component: require("@/components/Return/ReturnSchedulePage").default
    },
    {
      path: "/return/schedule/detail/:id",
      name: "ReturnScheduleDetail",
      component: require("@/components/Return/ReturnScheduleDetailPage").default
    },
    {
      path: "/return/schedule/partnership",
      name: "ReturnSchedulePartnership",
      component: require("@/components/Return/ReturnSchedulePartnershipPage")
        .default
    },
    {
      path: "/return/schedule/partnership/detail/:orderId",
      name: "OrderReturnSchedulePartnershipDetail",
      component: require("@/components/Return/ReturnSchedulePartnershipDetailPage")
        .default
    },
    {
      path: "/return/returned",
      name: "ReturnReturned",
      component: require("@/components/Return/ReturnReturnedPage").default
    },
    {
      path: "/return/returned/partnership",
      name: "ReturnReturnedPartnership",
      component: require("@/components/Return/ReturnReturnedPartnershipPage")
        .default
    },
    {
      path: "/return/returned/partnership/detail/:orderId",
      name: "ReturnedPartnershipDetail",
      component: require("@/components/Return/ReturnedPartnershipDetailPage")
        .default
    },
    {
      path: "/return/detail",
      name: "ReturnedDetail",
      component: require("@/components/Return/ReturnedDetailPage").default
    },
    {
      path: "/return/quality-control",
      name: "QualityControl",
      component: require("@/components/QC/QualityControl").default
    },
    {
      path: "/return/unmatch",
      name: "UnmatchProduct",
      component: require("@/components/UnmatchProduct/UnmatchProduct").default
    },
    {
      path: "/order/detail/lessor/:action",
      name: "SetLessor",
      component: require("@/components/Order/SetLessorPage").default
    },
    {
      path: "/order/detail/:orderId",
      name: "OrderDetail",
      component: require("@/components/Order/OrderDetailPage").default
    },
    {
      path: "/lost-item",
      name: "LostItemPage",
      component: require("@/components/Order/LostItemPage").default
    },
    // {
    //   path: "/order/detail/:orderId/past",
    //   name: "OrderDetailPast",
    //   component: require("@/components/Order/OrderDetailPagePast").default
    // },
    {
      path: "/rental/product",
      name: "ProductRenting",
      component: require("@/components/Order/ProductRentingPage").default
    },
    {
      path: "/resolution",
      name: "ResolutionCenter",
      component: require("@/components/Resolution/ResolutionCenterPage").default
    },
    {
      path: "/resolution/detail/:ticketId",
      name: "ResolutionCenterDetail",
      component: require("@/components/Resolution/ResolutionCenterDetailPage")
        .default
    },
    {
      path: "/product",
      name: "Product",
      component: require("@/components/Product/ProductPage").default
    },
    {
      path: "/product/top",
      name: "ProductTop",
      component: require("@/components/Product/ProductTopPage").default
    },
    {
      path: "/product/detail/:productId",
      name: "ProductDetail",
      component: require("@/components/Product/ProductDetailPage").default
    },
    {
      path: "/payment/pairing",
      name: "PaymentPairing",
      component: require("@/components/Payment/PaymentPairingPage").default
    },
    {
      path: "/payment/pairing/search",
      name: "PaymentPairingSearch",
      component: require("@/components/Payment/PaymentPairingPageSearch")
        .default
    },
    {
      path: "/payment/reconcile",
      name: "PaymentDueDate",
      component: require("@/components/Payment/PaymentReconcilePage").default
    },
    {
      path: "/partnership/lessee",
      name: "PartnershipLesse",
      component: require("@/components/Partnership/LesseePage").default
    },
    {
      path: "/partnership/lessee/detail/:companyId",
      name: "PartnershipLesseDetail",
      component: require("@/components/Partnership/LesseeDetailPage").default
    },
    {
      path: "/partnership/lessor",
      name: "PartnershipLessor",
      component: require("@/components/Partnership/LessorPage").default
    },
    {
      path: "/partnership/lessor/search",
      name: "PartnershipLessorSearch",
      component: require("@/components/Partnership/LessorPageSearch").default
    },
    {
      path: "/partnership/lessor/renting/detail/:lessorId",
      name: "PartnershipLessorDetailRenting",
      component: require("@/components/Partnership/LessorDetailRentingPage")
        .default
    },
    {
      path: "/partnership/lessor/renting/detail/:lessorId/search",
      name: "PartnershipLessorDetailRentingSearch",
      component: require("@/components/Partnership/LessorDetailRentingPageSearch")
        .default
    },
    {
      path: "/partnership/lessor/rented/detail/:lessorId",
      name: "PartnershipLessorDetailRented",
      component: require("@/components/Partnership/LessorDetailRentedPage")
        .default
    },
    {
      path: "/partnership/lessor/rented/detail/:lessorId/search",
      name: "PartnershipLessorDetailRentedSearch",
      component: require("@/components/Partnership/LessorDetailRentedPageSearch")
        .default
    },
    {
      path: "/partnership/admin",
      name: "PartnershipAdmin",
      component: require("@/components/Partnership/AdminPage").default
    },
    {
      path: "/partnership/lessee/verification",
      name: "PartnershipLesseVerification",
      component: require("@/components/Partnership/LesseeVerificationPage")
        .default
    },
    {
      path: "/partnership/lessee/verification/detail/:companyId",
      name: "PartnershipLesseVerificationDetail",
      component: require("@/components/Partnership/LesseeDetailVerificationPage")
        .default
    },
    {
      path: "/partnership/insurance",
      name: "PartnershipInsurance",
      component: require("@/components/Partnership/InsurancePage").default
    },
    // {
    //   path: '/stock/product',
    //   name: 'StockProduct',
    //   component: require('@/components/Stock/StockProductPage').default
    // },
    {
      path: "/stock/product",
      name: "StockProductNew",
      component: require("@/components/Stock/StockProductNew").default
    },
    {
      path: "/stockItem/:serial",
      name: "StockDetailPageNew",
      component: require("@/components/Stock/StockDetailNew").default
    },
    {
      path: "/stock/views/:id",
      name: "StockViewNew",
      component: require("@/components/Stock/StockViewPageNew").default
    },
    {
      path: "/assembly/change-spec",
      name: "ChangeSpec",
      component: require("@/components/Assembly/ChangeSpecPage").default
    },
    {
      path: "/assembly/perbaikan",
      name: "PerbaikanUnit",
      component: require("@/components/Assembly/PerbaikanUnitPage").default
    },
    {
      path: "/assembly/updateInfo",
      name: "UpdateInfo",
      component: require("@/components/Assembly/UpdateInfo").default
    },
    {
      path: "/assembly/sparepart-change",
      name: "PerbaikanUnit",
      component: require("@/components/Assembly/ChangeSparepartPage").default
    },
    {
      path: "/order/:orderId/extend",
      name: "orderExtend",
      component: require("@/components/Order/OrderExtendPage").default
    },
    // {
    //   path: "/sparepart",
    //   name: "Sparepart",
    //   component: require("@/components/Catalog/SparepartListPage").default
    // },
    {
      path: "/product/:pageActioun/unit",
      name: "productAddUnit",
      component: require("@/components/Product/ProductAddUnitPage").default
    },
    {
      path: "/product/:pageActioun/bundling",
      name: "productBundling",
      component: require("@/components/Product/ProductAddBundlingPage").default
    },
    // {
    //   path: "/procure",
    //   name: "procure",
    //   component: require("@/components/Procure/ProcurePage").default
    // },
    // {
    //   path: "/procure/create",
    //   name: "ProcureCreate",
    //   component: require("@/components/Procure/ProcureCreatePage").default
    // },
    // {
    //   path: "/procure/detail/:id",
    //   name: "ProcureDetail",
    //   component: require("@/components/Procure/ProcureDetailPage").default
    // },
    // {
    //   path: "/procure/detail/:id/add",
    //   name: "ProcureAddItem",
    //   component: require("@/components/Procure/ProcureCreatePage").default
    // },
    {
      path: "/inventory/sparepart",
      name: "InventorySparepart",
      component: require("@/components/Warehouse/InventorySparepartPage")
        .default
    },
    {
      path: "/inventory/sparepart/detail/:sku",
      name: "InventorySparepartDetail",
      component: require("@/components/Warehouse/InventorySparepartDetailPage")
        .default
    },
    {
      path: "/inventory/product",
      name: "InventoryProduct",
      component: require("@/components/Warehouse/InventoryProductPage").default
    },
    {
      path: "/inventory/product/detail/:id",
      name: "InventoryProductDetail",
      component: require("@/components/Warehouse/InventoryProductDetailPage")
        .default
    },
    {
      path: "/inventory/product/detail/:id/:stockCode/edit",
      name: "InventoryProductDetailEdit",
      component: require("@/components/Warehouse/InventoryProductDetailEditPage")
        .default
    },
    {
      path: "/inventory/product/addin",
      name: "InventoryProductAddInManual",
      component: require("@/components/Warehouse/InventoryProductAddInPage")
        .default
    },
    // {
    //   path: "/assembly",
    //   name: "assembly",
    //   component: require("@/components/Warehouse/AssemblyPage").default
    // },
    {
      path: "/orderlist",
      name: "OrderList",
      component: require("@/components/Warehouse/OrderListPage").default
    },
    {
      path: "/orderlist/detail/:id",
      name: "OrderListDetail",
      component: require("@/components/Warehouse/OrderListDetailPage").default
    },
    {
      path: "/order/:orderId/extend/edit",
      name: "orderExtendEdit",
      component: require("@/components/Order/OrderExtendEditPage").default
    },
    // {
    //   path: "/short-url",
    //   name: "shortUrl",
    //   component: require("@/components/Utility/ShortUrl").default
    // },
    {
      path: "/stock/summary",
      name: "StockSummary",
      component: require("@/components/Stock/StockSummary").default
    },
    {
      path: "/risk-management/cek",
      name: "CekSkor",
      component: require("@/components/RiskManagement/riskmg").default
    },
    {
      path: "/risk-management/history",
      name: "RiwayatCek",
      component: require("@/components/RiskManagement/riwayat").default
    },
    {
      path: "/risk-management/detail/:id",
      name: "detailriwayat",
      component: require("@/components/RiskManagement/detailRiwayat").default
    },
    {
      path: "/rental/upgrade",
      name: "UpgradeUnit",
      component: require("@/components/Order/UpgradeUnit").default
    },
    {
      path: "/rental/upgrade/create",
      name: "CreateUpgrade",
      component: require("@/components/Order/CreateUpgrade").default
    },
    {
      path: "/rental/upgrade/detail/:id",
      name: "DetailUpgrade",
      component: require("@/components/Order/DetailUpgrade").default
    },
    {
      path: "/rental/upgrade/edit/:id",
      name: "editUpgrade",
      component: require("@/components/Order/EditSpecAwal").default
    },
    {
      path: "/tag/order",
      name: "orderTag",
      component: require("@/components/Tag/OrderTag").default
    },
    {
      path: "/tag/lessee",
      name: "lesseeTag",
      component: require("@/components/Tag/LesseeTag").default
    },
    {
      path: "/reject/:token",
      name: "rejectProductAdjustment",
      component: require("@/components/Order/RejectProductAdjustmentPage")
        .default
    },
    {
      path: "/approve/:token",
      name: "approveProductAdjustment",
      component: require("@/components/Order/ApproveProductAdjustmentPage")
        .default
    },
    // Invoicing
    {
      path: "/invoicing/pending",
      name: "invoicePending",
      component: require("@/components/Invoicing/InvoicePendingPage").default
    },
    {
      path: "/invoicing/pending/detail",
      name: "createInvoice",
      component: require("@/components/Invoicing/InvoiceCreationPage").default
    },
    {
      path: "/invoicing/list",
      name: "invoiceList",
      component: require("@/components/Invoicing/InvoiceListPage").default
    },
    {
      path: "/invoicing/detail/:invoiceId",
      name: "invoiceListDetail",
      component: require("@/components/Invoicing/InvoiceDetailPage").default
    },
    {
      path: "/invoicing/payments",
      name: "invoicePaymentList",
      component: require("@/components/Invoicing/InvoicePaymentListPage")
        .default
    },
    {
      path: "/invoicing/payments/:id",
      name: "invoicePaymentDetail",
      component: require("@/components/Invoicing/InvoicePaymentDetail").default
    },
    {
      path: "/invoicing/confirm-payment",
      name: "invoicePaymentConfirmationList",
      component: require("@/components/Invoicing/InvoicePaymentConfirmationListPage")
        .default
    },
    {
      path: "/invoicing/ignore",
      name: "IgnoredInvoiceListPage",
      component: require("@/components/Invoicing/InvoiceIgnorePage")
        .default
    },
    {
      path: "/invoicing/ignore/detail",
      name: "IgnoredInvoiceDetailPage",
      component: require("@/components/Invoicing/InvoiceIgnoreDetailPage")
        .default
    },
    // Insurance
    {
      path: "/insurance/vendors",
      name: "insuranceVendorListPage",
      component: require("@/components/Insurance/VendorPage").default
    },
    {
      path: "/insurance/vendors/register",
      name: "insuranceVendorRegisterPage",
      component: require("@/components/Insurance/VendorRegistrationPage")
        .default
    },
    {
      path: "/insurance/pending",
      name: "insurancePendingDeclareListPage",
      component: require("@/components/Insurance/PendingDeclarePage").default
    },
    {
      path: "/insurance/batch",
      name: "insuranceBatchListPage",
      component: require("@/components/Insurance/BatchInsurancePage").default
    },
    {
      path: "/insurance/batch/:id",
      name: "detailInsuranceBatchPage",
      component: require("@/components/Insurance/DetailBatchInsurance").default
    },
    {
      path: "/insurance/polis",
      name: "insurancePolisListPage",
      component: require("@/components/Insurance/PolisListPage").default
    },
    {
      path: '*',
      name: 'NotFound',
      component: require('@/components/NotFoundPage').default
    }
  ]
});

router.afterEach((to, from) => {
  if (to.name == "PartnershipInsurance" && from.name && from.name !== to.name) {
    localStorage.setItem("selectInsurance", JSON.stringify([]));
  }

  if (to.name == "invoicePending" && from.name && from.name !== to.name) {
    localStorage.setItem("selectedPendingInvoice", JSON.stringify([]));
  }

  if (to.name == "invoiceList" && from.name && from.name !== to.name) {
    localStorage.setItem("selectedInvoiceData", JSON.stringify([]));
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js